import { PalletPattern } from '@/generated/model/palletPattern'
import { renumberBoxes } from '@/libs/pattern/layerSort'
import { LayerPattern } from '@/generated/model/layerPattern'
import { populateUniqueBoxIdsLayerPattern } from '@/libs/pattern/layerPatternUtils'

export const reorderAll = (palletPattern: PalletPattern): PalletPattern => {
  const box = palletPattern.box
  const settings = palletPattern.programSettings
  const result = JSON.parse(JSON.stringify(palletPattern))
  const pallet = result.pallet

  try {
    // @ts-ignore
    let updatedLayerPatterns: LayerPattern[] = []
    pallet.layerPatterns.forEach((pattern: LayerPattern) => {
      const updated = {...pattern}
      if (!pattern.manualOrder) {
        updated.boxPositions = renumberBoxes(pattern.boxPositions!, box!, true, pattern.boxGroups!, settings!.boxOrientationOnConveyor)
      }
      if (!pattern.manualOrderAlt) {
        updated.boxPositionsAlt = renumberBoxes(pattern.boxPositionsAlt!, box!, false, pattern.boxGroupsAlt!, settings!.boxOrientationOnConveyor)
      }
      populateUniqueBoxIdsLayerPattern(updated)

      fixPusherGroups(updated)

      updatedLayerPatterns = [...updatedLayerPatterns, updated]
      result.pallet.layerPatterns = updatedLayerPatterns
    })
  } catch (err) {
    console.log('[ERROR] ', err)
  }

  return result
}

// temp fix for faulty patterns
const fixPusherGroups = (pattern: LayerPattern) => {
  if (pattern.boxGroups && pattern.pusher && pattern.boxGroups.length < pattern.pusher.length) {
    pattern.pusher = pattern.pusher.slice(pattern.pusher.length - pattern.boxGroups.length)
  }
  if (pattern.boxGroupsAlt && pattern.pusherAlt && pattern.boxGroupsAlt.length < pattern.pusherAlt.length) {
    pattern.pusherAlt = pattern.pusherAlt.slice(pattern.pusherAlt.length - pattern.boxGroupsAlt.length)
  }
}
